module.exports = __webpack_public_path__ + "a1403afdb67d39f029dcce03dd7fceac.png";